import React, {useEffect} from 'react';
import {NodeModel} from '@minoru/react-dnd-treeview';
import {Button, ButtonToolbar, Col, Icon, ListItem, Menu, MenuDivider, MenuItem, Row, Space, Tag, Text} from '@mc/ui-v4';
import classNames from 'classnames';
import {mcDelete, mcEdit, mcLocation, mcMinus, mcMoveDown, mcMoveUp} from '@mc/react-ui-icons';
import {truncate} from '../../helpers/DataMutators';

type Props = {
    node: NodeModel;
    onToggle: () => void;
    removeItem: (data: NodeModel) => void;
    changeItem: (data: NodeModel) => void;
    moveItem?: (data: NodeModel, index: number) => void;
    treeData: NodeModel[];
    diskriminatorAtributId: number;
};

export const CustomNode: React.FC<Props> = props => {
    const {onToggle, node, removeItem, changeItem, moveItem, diskriminatorAtributId} = props;
    const {droppable, text} = node;

    const sameParentItems = props.treeData.filter(item => item.parent === node.parent);
    const currentIndex = sameParentItems.findIndex(item => item.id === node.id);
    const isDiscriminator = node.id && diskriminatorAtributId && node.id === diskriminatorAtributId;

    useEffect(() => onToggle(), []);

    return (
        <ListItem
            className={classNames('custom-node ', {
                skupina: droppable,
            })}
            bodyClassName="w-100"
        >
            <Row className="d-flex align-items-center w-100 py-0" noGutters>
                <Col>
                    {droppable ? (
                        <Text className='pl-1' strong={droppable} title={text}>
                            {truncate(text, 28)}
                        </Text>
                    ) : (
                        <Space>
                            <Tag color={'blue'} title={text}>
                                {truncate(text, 28)}
                            </Tag>
                            {isDiscriminator && <Icon title={'Atribut je diskriminátorem vrstvy'} icon={mcLocation} />}
                        </Space>
                    )}
                </Col>
                <Col className="d-flex justify-content-end">
                    {droppable ? (
                        <Button
                            className={'justify-self-end'}
                            style={'link'}
                            menu={
                                <Menu>
                                    <MenuItem
                                        onClick={() => changeItem(node)}
                                        text={
                                            <Text intent={'primary'} icon={<Icon icon={mcEdit} />}>
                                                Upravit skupinu
                                            </Text>
                                        }
                                    />
                                    <MenuDivider />
                                    <MenuItem
                                        onClick={() => removeItem(node)}
                                        text={
                                            <Text intent={'danger'} icon={<Icon icon={mcDelete} />}>
                                                Smazat skupinu
                                            </Text>
                                        }
                                    />
                                </Menu>
                            }
                        />
                    ) : (
                        <ButtonToolbar className="justify-content-end">
                            <Button
                                onClick={() => {
                                    moveItem(node, currentIndex - 1);
                                }}
                                disabled={currentIndex === 0}
                                style={'link'}
                                icon={<Icon icon={mcMoveUp} />}
                            />
                            <Button
                                onClick={() => {
                                    moveItem(node, currentIndex + 1);
                                }}
                                disabled={currentIndex === sameParentItems.length - 1}
                                style={'link'}
                                icon={<Icon icon={mcMoveDown} />}
                            />
                            <Button
                                disabled={isDiscriminator}
                                className={'justify-self-end'}
                                style={'link'}
                                icon={<Icon icon={mcMinus} />}
                                onClick={() => removeItem(node)}
                            />
                        </ButtonToolbar>
                    )}
                </Col>
            </Row>
        </ListItem>
    );
};
